import { t } from '@lingui/macro';

export default (isCatOnly: boolean): string =>
  isCatOnly
    ? t({
        message: `Find the Purrfect Match`,
        comment: "Either 'Find the Perfect Match' or 'Find the Purrfect Match'",
      })
    : t`Find the Perfect Match`;
